import { collectionEngineV1 } from '../apis';
const updatesAPI = collectionEngineV1('/procedures');
export const run = (procedureId, caseId) => updatesAPI('POST', `/${procedureId}/run`, {
    body: {
        caseId,
    },
});
export const get = (casualConsistency) => updatesAPI('GET', `/${casualConsistency ? '?casualConsistency=true' : ''}`);
export const create = (newProcedure) => updatesAPI('POST', '/', {
    body: newProcedure,
});
export const patch = (procedureId, newProcedure) => updatesAPI('PATCH', '/' + procedureId, {
    body: newProcedure,
});
//# sourceMappingURL=procedures.js.map